import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
  body {
    background: linear-gradient(80deg, #000000 50%, #000000);
    color: #fff;
   
  }
`;

export default GlobalStyle;
